import { render, staticRenderFns } from "./myTalentInfo.vue?vue&type=template&id=2ccf11e4&scoped=true"
import script from "./myTalentInfo.vue?vue&type=script&lang=js"
export * from "./myTalentInfo.vue?vue&type=script&lang=js"
import style0 from "./myTalentInfo.vue?vue&type=style&index=0&id=2ccf11e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccf11e4",
  null
  
)

export default component.exports